// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customBackgroundColor[data-v-1548c736] {\n  border-radius: 2px 0px 0px 0px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n  background: rgba(26, 123, 238, 0.1);\n}\n.right-border[data-v-1548c736] {\n  border-right: 1px solid #e6e6e6;\n  border-right-width: 1px;\n  height: 40%;\n}\n", ""]);
// Exports
module.exports = exports;
